import React, { useEffect, useState } from 'react';
import { Text, View } from "../../../src/Components/Themed";
import type { LeagueProps, TeamProps, TeamRankingProps, TeamRecordProps } from '../../../src/types';
import { MarketComponentApi } from '../../../src/MarketComponents/api';
import { Image } from 'react-native';
import { MarketAppHelpers } from '../helpers';

type TeamCardProps = {
    team_id:string
}
const TeamCard = ({team_id}:TeamCardProps) => {
    const [ team_state, setTeamState ] = useState<{
        loading:boolean,
        team?:TeamProps,
        league?:LeagueProps,
        team_rankings:TeamRankingProps[],
        team_records:TeamRecordProps[]
    }>({
        loading:false,
        team_rankings:[],
        team_records: []
    });
    const { loading, league, team, team_rankings, team_records } = team_state;
    const default_record = MarketAppHelpers.getDefaultRecord(team_records, league);
    console.log(team_records)
    useEffect(() => {
        getData(team_id)
    },[team_id]);

    const getData = async(id:string) => {
        setTeamState({ ...team_state, loading:true });
        const team_data = await MarketComponentApi.getTeamById(id);
        if(!team_data){ return }//Failed to get data
        setTeamState({
            ...team_state,
            loading:false,
            team: team_data.team,
            league: team_data.league,
            team_rankings: team_data.team_rankings,
            team_records: team_data.team_records
        });
    }
    if(!team){ return <></> }
    return (
        <View>
            <Image
                source={{ uri: team.image?.url }}
                style={{ height:40, width:40 }}
                resizeMode='contain'
            />
            <View>
                <Text>{team.market_name} {team.name}</Text>
                {default_record ?
                <Text>{team.division} - {team.sub_division}</Text>
                :<></>}
            </View>
        </View>
    )
}

export default TeamCard